export default {"src":"/_next/static/media/effect-dots.e3c01b02.svg","height":640,"width":1441,"blurWidth":0,"blurHeight":0};